// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


//ui组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { size: 'medium', zIndex: 1000 });

//全局函数
import Tools from './util/tools'
Vue.use(Tools);

//网络请求
import Axios from './util/Axios'
Vue.prototype.$http = Axios

//参数处理
import qs from 'qs';
Vue.prototype.$qs = qs;

//状态管理
import Store from './vuex/store'


//拖拽组件
// import MINEH5UI from 'mine-h5-ui'
// import 'mine-h5-ui/lib/theme-default/index.css'
// Vue.use(MINEH5UI)
import '@wangeditor/editor/dist/css/style.css' // 引入 v5 必需样式

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store:Store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js